<template>
  <v-container>

    <v-dialog
      v-model="dialog"
      width="580"
      persistent
    >
      <v-card>
        <v-card-title>
          Verification
          <v-spacer/>
          <v-btn
            icon
            link
            to="/logout.json"
          >
            <v-icon small>logout</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row class="mx-0" v-if="!$store.state.auth.user.settings.verified.email">
            <v-text-field
              v-model="$store.state.auth.user.settings.email"
              label="Email"
              hide-details
              class="col-5 ml-0 pl-0"
            ></v-text-field>
            <v-text-field
              v-model="codes.email"
              :loading="loading.email"
              :disabled="loading.email"
              label="Code"
              hide-details
              class="col-3"
            />

            <v-btn
              small
              class="mt-5 ml-2 mr-3"
              color="info"
              :loading="loading.email"
              :disabled="loading.email"
              @click="enable('email')"
            >
              Enable
            </v-btn>

            <v-btn
              small
              :dark="!loading.email"
              class="mt-5"
              color="teal"
              :loading="loading.email"
              :disabled="loading.email"
              @click="resend('email')"
            >
              Resend
            </v-btn>
          </v-row>
          <v-row class="mx-0" v-if="!$store.state.auth.user.settings.verified.phone">
            <v-text-field
              v-model="$store.state.auth.user.settings.phone"
              label="Phone"
              hide-details
              class="col-5 ml-0 pl-0"
            />
            <v-text-field
              v-model="codes.phone"
              :loading="loading.phone"
              :disabled="loading.phone"
              label="Code"
              hide-details
              class="col-3"
            />

            <v-btn
              small
              class="mt-5 ml-2 mr-3"
              color="info"
              :loading="loading.phone"
              :disabled="loading.phone"
              @click="enable('phone')"
            >
              Enable
            </v-btn>

            <v-btn
              small
              class="mt-5"
              :dark="!loading.phone"
              color="teal"
              :loading="loading.phone"
              :disabled="loading.phone"
              @click="resend('phone')"
            >
              Resend
            </v-btn>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import { API } from '@/utils/api'

  export default {
    data: () => ({
      dialog: true,
      loading: {
        email: false,
        phone: false,
      },
      codes: {
        email: '',
        phone: '',
      }
    }),

    mounted () {
      if (this.$store.state.auth.user.settings.verified.email && this.$store.state.auth.user.settings.verified.phone) {
        this.$router.push('/')
      }
    },

    methods: {
      enable (type) {
        return API.call('/activate.json', { [type]: this.codes[type] }).then(resp => {
          this.$store.state.auth.user.settings.verified[type] = resp.data[type]

          if (!resp.data[type]) {
            this.$notification.show = true
            this.$notification.message = 'Wrong Code!'
            this.$notification.type = 'error'
          }

          if (this.$store.state.auth.user.settings.verified.email && this.$store.state.auth.user.settings.verified.phone) {
            this.$router.push('/')
          }
        }).catch(e => {
        }).finally(() => {
          this.loading[type] = false
        })
      },
      resend (type) {

        this.loading[type] = true
        return API.call('/resend.json', { [type]: this.$store.state.auth.user.settings[type] }).catch(e => {
        }).finally(() => {
          this.loading[type] = false
        })
      }
    }

  }
</script>
